/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDefinitionColumnChangeEvent } from './businessObjectDefinitionColumnChangeEvent';
import { BusinessObjectDefinitionColumnKey } from './businessObjectDefinitionColumnKey';


export interface BusinessObjectDefinitionColumn { 
    /**
     * The internal Id that uniquely references a Business Object Definition Column
     */
    id?: number;
    businessObjectDefinitionColumnKey: BusinessObjectDefinitionColumnKey;
    /**
     * The name of the schema column
     */
    schemaColumnName?: string;
    /**
     * Description of the Business Object Definition Column
     */
    description?: string;
    /**
     * An optional boolean flag that specifies if this column is a primary key column or belongs to a set of primary key columns                
     */
    isPrimaryKeyColumn?: boolean;
    /**
     * A list of business object definition column change events
     */
    businessObjectDefinitionColumnChangeEvents?: Array<BusinessObjectDefinitionColumnChangeEvent>;
}
